import mapValues from 'lodash/mapValues';

import {
  ConditionalTaskProperties,
  DataExportTaskProperties,
  PropertiesType,
} from '../../types';
import { LabwarePropertiesV1 } from '../migrateTo1';
import { CodeTaskProperties, TaskPropertiesV3 } from '../migrateTo3';
import { LoadedWorkflowV4 } from '../migrateTo4';

type TaskPropertiesV5 = TaskPropertiesV3 & {
  labwareIdsToUnitsConsumed: { [labwareId: string]: number | null };
};

type LabwarePropertiesV5 = LabwarePropertiesV1 & {
  totalUnits: number | null;
};

type VisualWorkflowV5 = Omit<
  LoadedWorkflowV4['visualWorkflow'],
  'taskProperties' | 'labwareProperties' | 'codeTaskProperties'
> & {
  taskProperties: Record<
    string,
    | TaskPropertiesV5
    | CodeTaskProperties
    | DataExportTaskProperties
    | ConditionalTaskProperties
  >;
  labwareProperties: Record<string, LabwarePropertiesV5>;
};

export type LoadedWorkflowV5 = Omit<LoadedWorkflowV4, 'visualWorkflow'> & {
  visualWorkflow: VisualWorkflowV5;
};

export const _migrateTo5 = (
  loadedWorkflow: LoadedWorkflowV4
): LoadedWorkflowV5 => {
  const taskProperties = mapValues(
    loadedWorkflow.visualWorkflow.taskProperties,
    (task, _id) => {
      if (task.propertiesType === PropertiesType.Action) {
        return {
          ...task,
          labwareIdsToUnitsConsumed: {},
        } satisfies TaskPropertiesV5;
      }
      return task;
    }
  );

  const labwareProperties = mapValues(
    loadedWorkflow.visualWorkflow.labwareProperties,
    (labware, _id): LabwarePropertiesV5 => ({
      ...labware,
      // This migration intentionally resets any 'multi' values to 'single'.
      // Tipracks used to default to 'multi' which did not drive any behavior.
      singleOrMultiUse: 'single',
      totalUnits: null,
    })
  );

  return {
    ...loadedWorkflow,
    visualWorkflow: {
      ...loadedWorkflow.visualWorkflow,
      taskProperties,
      labwareProperties,
    },
  };
};
